import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import SearchPage from './searchPage';
import SlidingMenu from './slidingMenu';
import { getCartItems } from '../services/cartService';

class Navbar extends Component {
  state = {
    menuopen: false,
    cartopen: false,
    searchPage: false,
    cartItems: [],
  };

  componentDidMount() {
    this.setState({ cartopen: this.props.cartopen, cartItems: this.props.cartItems });
  }

  async componentDidUpdate(prevProps) {
  //  this.setState({ cartItems: getCartItems() });
    if (prevProps.cartItems !== this.props.cartItems)
      this.setState({ cartItems:this.props.cartItems });
    
    if (this.props.cartopen !== prevProps.cartopen) {
      this.setState({ cartopen: true });
      this.setState({ cartItems: getCartItems() });
    }
  }

  handleBurgerMenu = () => {
    let { menuopen, cartopen } = this.state;
    menuopen = !menuopen;
    if (cartopen) this.setState({ cartopen: false });
    this.setState({ menuopen });
  };

  handleCartBlock = () => {
    let { cartopen, menuopen } = this.state;
    cartopen = !cartopen;
    if (menuopen) this.setState({ menuopen: false });

    this.setState({ cartopen });
  };

  handleSearchPage = () => {
    let { searchPage } = this.state;
    searchPage = !searchPage;
    this.setState({ searchPage });
  };

  render() {
    const { menuopen, cartopen, searchPage, cartItems } = this.state;
    let delay = 0;
    let key = 1.1;
    const { user } = this.props;

    return (
      <React.Fragment>
        <div className='navbar'>
          <div className='burger-menu' onClick={this.handleBurgerMenu}>
            <div className={menuopen ? 'burger-block-crossed' : 'burger-block'}>
              <div className='burger-upper-line'></div>
              <div className='burger-bottom-line'></div>
            </div>
          </div>

          <div className='short-menu-block'>
            <Link
              onClick={
                menuopen
                  ? this.handleBurgerMenu
                  : cartopen
                  ? this.handleCartBlock
                  : null
              }
              to='/products/'
            >
              Products
            </Link>
            {!user && (
              <React.Fragment>
                <Link
                  onClick={
                    menuopen
                      ? this.handleBurgerMenu
                      : cartopen
                      ? this.handleCartBlock
                      : null
                  }
                  to='/login/'
                >
                  Login
                </Link>

                <Link
                  onClick={
                    menuopen
                      ? this.handleBurgerMenu
                      : cartopen
                      ? this.handleCartBlock
                      : null
                  }
                  to='/signup/'
                >
                  Create account
                </Link>
              </React.Fragment>
            )}
            {user && (
              <React.Fragment>
                <Link
                  onClick={
                    menuopen
                      ? this.handleBurgerMenu
                      : cartopen
                      ? this.handleCartBlock
                      : null
                  }
                  to='/dashboard/'
                >
                  Dashboard
                </Link>
                <Link
                  onClick={
                    menuopen
                      ? this.handleBurgerMenu
                      : cartopen
                      ? this.handleCartBlock
                      : null
                  }
                  to='/logout/'
                >
                  Logout
                </Link>
              </React.Fragment>
            )}
          </div>

          <div className='logobox'>
            <h3 className='logo'>
              <Link
                onClick={
                  menuopen
                    ? this.handleBurgerMenu
                    : cartopen
                    ? this.handleCartBlock
                    : null
                }
                to='/'
              >
                Beverix
              </Link>
            </h3>
          </div>

          {user && (
            <div className='navbar-user'>
              <Link
                onClick={
                  menuopen
                    ? this.handleBurgerMenu
                    : cartopen
                    ? this.handleCartBlock
                    : null
                }
                to='/profile/'
              >
                <div
                  className='nav-user-image'
                  style={{ backgroundImage: 'url(' + user.profilePic + ')' }}
                ></div>
              </Link>
              <Link
                onClick={
                  menuopen
                    ? this.handleBurgerMenu
                    : cartopen
                    ? this.handleCartBlock
                    : null
                }
                to='/profile/'
              >
                {user.name}
              </Link>
            </div>
          )}

          <div className='search-icon' onClick={this.handleSearchPage}>
            <i className='fas fa-search'></i>
          </div>
          <div className='cart-header' onClick={this.handleCartBlock}>
            <i className='fas fa-shopping-bag'></i>
            {cartItems.length > 0 && (
              <span className='cart-badge ml-2'>{cartItems.length}</span>
            )}
          </div>
        </div>

        {menuopen && (
          <div
            onClick={this.handleBurgerMenu}
            className='back-behind-menu'
          ></div>
        )}

        {cartopen && (
          <div
            onClick={this.handleCartBlock}
            className='back-behind-menu'
          ></div>
        )}

        {searchPage && (
          <SearchPage
            handleSearchPage={this.handleSearchPage}
            
          />
        )}

        <SlidingMenu
          user={user}
          menuopen={menuopen}
          handleBurgerMenu={this.handleBurgerMenu}
        />

        <div
          className={
            cartopen ? 'sliding-cart cartopen' : 'sliding-cart cartclose'
          }
        >
          <h4 className='cart-heading'>
            {cartItems.length > 0
              ? 'Your Cart (' + cartItems.length + ')'
              : 'Your shopping cart is empty'}
          </h4>
          <div className='cart-inner-block'>
            {cartopen &&
              cartItems.map((c) => (
                <React.Fragment key={key++}>
                  <div
                    className='cart-product-block'
                    style={{ animationDelay: `${(delay += 0.07)}s` }}
                  >
                    <img src={c.product.imageUrl} alt='pro' />
                    <div className='cart-product-details'>
                      <div className='upper-text-cart'>
                        <Link
                          onClick={cartopen ? this.handleCartBlock : null}
                          to={`/products/product/${c.product._id}`}
                        >
                          <h4>{c.product.label}</h4>
                        </Link>
                        <h5 className="hide-col">{c.product.size}</h5>
                        <h5>PKR {c.product.price}</h5>
                      </div>
                      <h6 className='total-price'>
                        Total: PKR {c.product.price * c.quantity}
                      </h6>
                    </div>

                    <div className='cart-quantity'>
                      <button
                        className='decrement'
                        disabled={c.quantity <= 1}
                        onClick={() => this.props.handleCartQuantity('dec', c)}
                      >
                        -
                      </button>
                      <div className='counter-value'>
                        <input
                          type='number'
                          value={c.quantity}
                          readOnly
                          onChange={this.handleQuantityValue}
                        />
                      </div>
                      <button
                        className='increment'
                        disabled={c.quantity >= c.product.inStock}
                        onClick={() => this.props.handleCartQuantity('inc', c)}
                      >
                        +
                      </button>
                    </div>

                    <button
                      onClick={() => this.props.deleteFromCart(c)}
                      className='cart-remove-btn'
                    >
                      x
                    </button>
                  </div>
                  {c.product.error && <div   style={{ animationDelay: `${(delay += 0.07)}s` }} className='alert alert-danger'>{c.product.error}</div>}
                  <div className='linee'></div>
                </React.Fragment>
              ))}
          </div>
          <div className='subtotal'>
            <h4>Subtotal: </h4>
            <h4>PKR {this.calculateTotal()}</h4>
          </div>
          <Link to='/checkout'>
            <button
              onClick={cartopen ? this.handleCartBlock : null}
              className='checkout-btn'
            >
              Checkout
            </button>
          </Link>
        </div>
      </React.Fragment>
    );
  }

  calculateTotal = () => {
    let total = 0;
    const { cartItems } = this.props;

    for (const c of cartItems) total = total + c.product.price * c.quantity;

    return total;
  };
}

export default Navbar;
